/* @flow */

export * from './ie';



// WEBPACK FOOTER //
// ./node_modules/post-robot/src/compat/index.js